import { render } from "./customerCRUD.vue?vue&type=template&id=799ec528&scoped=true"
import script from "./customerCRUD.vue?vue&type=script&lang=js"
export * from "./customerCRUD.vue?vue&type=script&lang=js"

import "./customerCRUD.vue?vue&type=style&index=0&id=799ec528&scoped=true&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799ec528"]])

export default __exports__